import React from 'react';
import PropTypes from 'prop-types';

import { INSURANCE_TYPE_DENTOLO, INSURANCE_TYPE_PETOLO } from '../../shared';
import useInsuranceInfo from '../../hooks/useInsuranceInfo';

import {
  StyledLoadingContainer,
  StyledLoadingSvgDentolo,
  StyledLoadingSvgPetolo,
  StyledLoadingText,
  StyledSvgRectangleDentolo,
  StyledSvgRectanglePetolo,
} from './styled/Loading.styled';

const AnimatedLogoPetolo = () => {
  return (
    <StyledLoadingSvgPetolo
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="46.6"
      height="62.5"
      viewBox="0 0 46.67 62.5"
    >
      <mask
        id="mask0"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="70"
        shapeRendering="auto"
      >
        <path
          d="M119.161 149.244V0H88.3916V65.958C85.035 59.8094 75.8042 51.7044 55.6643 51.7044C22.9371 51.7044 0 78.2553 0 112.073C0 147.008 23.4965 173 56.5035 173C72.1678 173 83.9161 166.013 88.951 156.79C88.951 162.1 89.7902 167.969 90.0699 170.205H120C119.72 165.454 119.161 157.069 119.161 149.244ZM82.7972 130.798C77.4825 141.977 67.1329 147.008 55.9441 146.449C42.5175 145.89 32.1678 137.226 29.3706 123.252C28.5315 119.619 28.2517 116.265 28.5315 112.632H86.4336C86.4336 118.78 85.5944 124.929 82.7972 130.798Z"
          fill="#9E2222"
          shapeRendering="auto"
        />
      </mask>
      <g transform="matrix(2.47 0 0 2.47 23.33 31.04)">
        <path
          d="m 426.23129 283.42674 c -0.3165 -1.0085 -0.8328 -1.9433 -1.5184 -2.74895 c -0.667 -0.77929 -1.4968 -1.40375 -2.4312 -1.82966 c -1.026 -0.4567 -2.14 -0.68317 -3.26338 -0.66343 c -1.11973 -0.03449 -2.23033 0.21096 -3.23061 0.71401 c -0.77948 0.37878 -1.4383 0.96581 -1.90317 1.69578 l 0 -2.03493 l -4.38504 0 l 0 23.13098 l 4.52226 0 l 0 -8.0743 c 0.48733 0.6286 1.12539 1.1248 1.85544 1.4429 c 0.93669 0.42 1.95643 0.6234 2.98302 0.595 c 1.11188 0.0134 2.21368 -0.2118 3.23058 -0.6604 c 0.9545 -0.4253 1.8068 -1.0491 2.4998 -1.8297 c 0.71 -0.8142 1.2532 -1.7592 1.5989 -2.7816 c 0.3826 -1.1307 0.5722 -2.3174 0.5608 -3.5106 c 0.009 -1.1684 -0.1661 -2.331 -0.519 -3.4451 z m -7.04295 -0.7795 c 0.07315 -0.1109 0.16882 -0.2053 0.28084 -0.277 c 0.11201 -0.0718 0.23791 -0.1193 0.36941 -0.1395 c 0.1846 -0.0237 0.372 0.0105 0.5361 0.098 c 0.1642 0.0874 0.2969 0.2237 0.3797 0.3899 c 0.1851 0.307 0.2781 0.6603 0.2681 1.0183 c -0.0101 0.358 -0.1228 0.7057 -0.3247 1.0018 c -0.071 0.1323 -0.1728 0.2457 -0.2969 0.3306 c -0.1241 0.0849 -0.2668 0.1388 -0.4161 0.1573 c -0.1933 0.0219 -0.3887 -0.0182 -0.55761 -0.1145 c -0.16896 -0.0963 -0.30277 -0.2438 -0.38203 -0.421 c -0.08893 -0.1831 -0.16276 -0.3732 -0.22074 -0.5682 c -0.07718 -0.5205 0.05349 -1.0503 0.36393 -1.4757 z m -3.40064 0.7765 c 0.09136 -0.204 0.26004 -0.3636 0.46913 -0.4439 c 0.20909 -0.0803 0.44155 -0.0747 0.64651 0.0155 c 0.28297 0.1224 0.53139 0.3123 0.72335 0.553 c 0.19197 0.2408 0.32157 0.5249 0.37739 0.8274 c 0.07754 0.3045 0.05023 0.6262 -0.07756 0.9134 c -0.04312 0.1036 -0.1067 0.1975 -0.18696 0.276 c -0.08026 0.0786 -0.17555 0.1403 -0.28021 0.1814 c -0.10466 0.0411 -0.21653 0.0607 -0.32897 0.0578 c -0.11243 -0.003 -0.22312 -0.0284 -0.32547 -0.0749 c -0.26015 -0.1061 -0.49158 -0.2719 -0.67556 -0.4838 c -0.18398 -0.2119 -0.31533 -0.464 -0.38342 -0.736 c -0.12818 -0.3536 -0.1132 -0.7431 0.04177 -1.0859 z m 0.48324 4.3704 c -0.09723 0.1466 -0.2402 0.2573 -0.4068 0.3149 c -0.16661 0.0575 -0.34758 0.0587 -0.51495 0.0034 c -0.34014 -0.0943 -0.64288 -0.2909 -0.86705 -0.5629 c -0.22417 -0.272 -0.35888 -0.6063 -0.38582 -0.9574 c -0.00791 -0.1176 0.01127 -0.2356 0.05607 -0.3447 c 0.04479 -0.1092 0.11402 -0.2066 0.20239 -0.285 c 0.08837 -0.0784 0.19354 -0.1356 0.30747 -0.1672 c 0.11393 -0.0316 0.2336 -0.0368 0.34986 -0.0152 c 0.33805 0.0641 0.64901 0.228 0.8926 0.4704 c 0.24359 0.2424 0.40859 0.5521 0.47362 0.8892 c 0.04983 0.2238 0.01138 0.4581 -0.10739 0.6545 z m 5.94215 2.3651 c -0.3861 0.0144 -0.7727 0.0035 -1.1574 -0.0327 c -0.5455 -0.0765 -1.1009 -0.04 -1.63169 0.1071 c -0.36248 0.1323 -0.71705 0.2853 -1.06196 0.4582 c -0.2983 0.1338 -0.55782 0.2975 -0.84718 0.4313 c -0.07841 0.0516 -0.16834 0.0831 -0.26185 0.0918 c -0.09351 0.0088 -0.18774 -0.0056 -0.27438 -0.0417 c -0.08665 -0.0362 -0.16304 -0.093 -0.22247 -0.1656 c -0.05942 -0.0725 -0.10005 -0.1585 -0.1183 -0.2504 c -0.27235 -0.7124 -0.28082 -1.4983 -0.02387 -2.2164 c 0.24551 -0.7607 0.69532 -1.4398 1.3006 -1.9635 c 0.25182 -0.2424 0.56789 -0.4078 0.91091 -0.4769 c 0.34303 -0.0691 0.69869 -0.0388 1.02509 0.0871 c 1.061 0.3265 1.9504 1.0565 2.4759 2.032 c 0.1141 0.2489 0.2137 0.5042 0.2983 0.7646 c 0.0179 0.232 0.0417 0.4314 0.0447 0.6307 c 0.0092 0.0662 0.0045 0.1336 -0.014 0.1978 c -0.0185 0.0643 -0.0502 0.124 -0.0932 0.1753 c -0.043 0.0512 -0.0963 0.093 -0.1564 0.1225 c -0.0601 0.0295 -0.1258 0.0461 -0.1928 0.0488 z m 0.4624 -3.5105 c -0.0956 0.0608 -0.2034 0.1 -0.3158 0.115 c -0.1124 0.0149 -0.2268 0.0052 -0.335 -0.0285 c -0.1082 -0.0337 -0.2078 -0.0906 -0.2917 -0.1667 c -0.0839 -0.0761 -0.1501 -0.1696 -0.194 -0.2739 c -0.1308 -0.3481 -0.1432 -0.7294 -0.0354 -1.0852 c 0.1078 -0.3559 0.3298 -0.6666 0.632 -0.8842 c 0.1078 -0.0821 0.2349 -0.1353 0.3691 -0.1545 c 0.1343 -0.0191 0.2712 -0.0037 0.3978 0.045 c 0.1265 0.0486 0.2385 0.1288 0.3251 0.2328 c 0.0867 0.1041 0.1451 0.2286 0.1698 0.3616 c 0 0.0357 0 0.0714 0.0239 0.1101 c 0.0567 0.3292 0.0165 0.6677 -0.1159 0.9745 c -0.1324 0.3068 -0.3512 0.5688 -0.6299 0.754 z"
          transform=" translate(-418.13, -289.94)"
          strokeLinecap="round"
          fill="#ffa445"
          shapeRendering="auto"
        />
        <StyledSvgRectanglePetolo
          x="-10"
          y="-12"
          width="20"
          height="70"
          fill="white"
          shapeRendering="auto"
        />
      </g>
    </StyledLoadingSvgPetolo>
  );
};

const AnimatedLogoDentolo = () => {
  return (
    <StyledLoadingSvgDentolo
      width="120"
      height="173"
      viewBox="0 0 120 173"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="120"
        height="273"
        shapeRendering="auto"
      >
        <path
          d="M119.161 149.244V0H88.3916V65.958C85.035 59.8094 75.8042 51.7044 55.6643 51.7044C22.9371 51.7044 0 78.2553 0 112.073C0 147.008 23.4965 173 56.5035 173C72.1678 173 83.9161 166.013 88.951 156.79C88.951 162.1 89.7902 167.969 90.0699 170.205H120C119.72 165.454 119.161 157.069 119.161 149.244ZM82.7972 130.798C77.4825 141.977 67.1329 147.008 55.9441 146.449C42.5175 145.89 32.1678 137.226 29.3706 123.252C28.5315 119.619 28.2517 116.265 28.5315 112.632H86.4336C86.4336 118.78 85.5944 124.929 82.7972 130.798Z"
          fill="#9E2222"
          shapeRendering="auto"
        />
      </mask>
      <g mask="url(#mask0)" shapeRendering="auto">
        <path
          d="M119.161 149.244V0H88.3916V65.958C85.035 59.8094 75.8042 51.7044 55.6643 51.7044C22.9371 51.7044 0 78.2553 0 112.073C0 147.008 23.4965 173 56.5035 173C72.1678 173 83.9161 166.013 88.951 156.79C88.951 162.1 89.7902 167.969 90.0699 170.205H120C119.72 165.454 119.161 157.069 119.161 149.244ZM82.7972 130.798C77.4825 141.977 67.1329 147.008 55.9441 146.449C42.5175 145.89 32.1678 137.226 29.3706 123.252C28.5315 119.619 28.2517 116.265 28.5315 112.632H86.4336C86.4336 118.78 85.5944 124.929 82.7972 130.798Z"
          fill="#003366"
          shapeRendering="auto"
        />
        <StyledSvgRectangleDentolo
          width="145"
          height="170"
          x="-10"
          y="0"
          fill="white"
          shapeRendering="auto"
        />
      </g>
    </StyledLoadingSvgDentolo>
  );
};

const getAnimatedLogo = (insuranceType) => {
  switch (insuranceType) {
    case INSURANCE_TYPE_DENTOLO:
      return <AnimatedLogoDentolo />;
    case INSURANCE_TYPE_PETOLO:
      return <AnimatedLogoPetolo />;
    default:
      return <AnimatedLogoDentolo />;
  }
};

const Loading = ({ text, showLogo }) => {
  const { type: insuranceType } = useInsuranceInfo();

  return (
    <StyledLoadingContainer>
      {showLogo && getAnimatedLogo(insuranceType)}
      {text && <StyledLoadingText>{text}</StyledLoadingText>}
    </StyledLoadingContainer>
  );
};

Loading.propTypes = {
  text: PropTypes.string,
  showLogo: PropTypes.bool,
};

export default Loading;
